import { render } from "./Wireguard.vue?vue&type=template&id=7c0a74fc&scoped=true"
import script from "./Wireguard.vue?vue&type=script&lang=js"
export * from "./Wireguard.vue?vue&type=script&lang=js"

import "./Wireguard.vue?vue&type=style&index=0&id=7c0a74fc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c0a74fc"]])

export default __exports__